<template lang="pug">
    div
        template(v-if="formItem.multiSelectWithToolbox && !disabled")
            // 全選
            Button(icon="md-done-all" size="small" @click="selectAll")
            // 反選
            Button(icon="md-swap" size="small" @click="reverseSelect")
            // 清空
            Button(icon="md-trash" size="small" @click="clearSelect")
        // code {{ options }}
        // br
        // code withOptionGroup {{ withOptionGroup }}
        v-select(
            class="style-chooser"
            :value="value"
            :options="options"
            :multiple="multiple"
            :taggable="selectAllowCreate"
            :push-tags="selectAllowCreate"
            :placeholder="placeholder"
            :reduce="reduce"
            :create-option="createOption"
            @search="getOptionsDebounce"
            :filterable="!isRemoteOptions"
            @input="onValueChanged"
            :clearable="clearable"
            ref="vselect"
            :selectable="option => !option.hasOwnProperty('optionGroupName') && !option.disabled"
            :disabled="disabled"
        )

            // 顯示選項資料
            template(slot="option" slot-scope="option")
                OptionSlot(:withOptionGroup="withOptionGroup" :option="option")

            // 顯示綁定資料
            template(slot="selected-option" slot-scope="option")
                span {{ option.label }}

            // 查無資料
            span(slot="no-options") {{ $t('main.selectNotFoundText') }}
</template>
<script>
import OptionSlot from "./Options";
import { getFormOptions } from "@/api/formoptions";
import { _debounce } from "@/libs/utils";
import { queryParamsFieldsCompletion } from "@/libs/rcmTableFieldsFunction";

export default {
    props: {
        formItem: {
            type: Object,
            default: () => ({}),
        },
        formData: {
            type: Object,
            default: () => ({}),
        },
        value: { type: [String, Array, Number], default: () => ["", []] }, //type加上Number, 因為console一直跳出[Vue warn]: Invalid prop: type check failed for prop "value". Expected String, Array, got Number with value 60 and 4.
        // value: {
        //     type: Array,
        //     default: function () {
        //         return ["", [], 0];
        //     },
        // },
    },
    components: { OptionSlot },
    watch: {},
    data() {
        return {
            options: this.formItem.options,
            placeholder: this.formItem.placeholder || "Select",
            selectAllowCreate: this.formItem.selectAllowCreate,
            inputValType: this.formItem.inputValType,
            clearable: this.formItem.clearable == true,
            withOptionGroup: this.formItem.withOptionGroup == true,
            queryParamsFields: this.formItem.queryParamsFields || [],
            onQueryParamFieldsQueryIf: this.formItem.onQueryParamFieldsQueryIf || "resetField",
        };
    },
    methods: {
        selectAll() {
            var options = this.withOptionGroup
                ? this.options.filter((option) => typeof option !== "object" || !option.optionGroupName)
                : this.options;
            var selectedItems = options.map((e) => (typeof e == "object" ? e.value : e));
            this.$emit("input", selectedItems);
        },
        reverseSelect() {
            var options = this.withOptionGroup
                ? this.options.filter((option) => typeof option !== "object" || !option.optionGroupName)
                : this.options;
            var selectedItems = options
                .map((e) => (typeof e == "object" ? e.value : e))
                .filter((e) => !this.value.includes(e));
            this.$emit("input", selectedItems);
        },
        clearSelect() {
            var selectedItems = [];
            this.$emit("input", selectedItems);
        },
        onValueChanged(value) {
            this.$emit("input", value);
            if (typeof this.formItem.watchField == "function") this.formItem.watchField(value, this.formData);
        },
        reduce(option) {
            return option.value !== undefined ? option.value : option;
        },
        createOption(option) {
            return this.inputValType == "Number" ? parseInt(option) : option;
        },
        shapeOptionGroupOptions(options) {
            let optionsFlatten = [];
            options.forEach((optionGroup) => {
                optionsFlatten.push({
                    optionGroupName: optionGroup.optionGroupName,
                    value: optionGroup.optionGroupName,
                });
                optionGroup.options.forEach((option) => {
                    optionsFlatten.push(option);
                });
            });
            return optionsFlatten;
        },
    },
    mounted() {
        if (this.isRemoteOptions) {
            // 在意的欄位中, 所有人符合 queryIf 條件, 才可以在 mounted 時獲取選項
            let isAllFieldsMatch = this.queryParamsFields.every((field) =>
                field.queryIf(this.formData[field.fieldName])
            );
            let canGetOptions = this.queryParamsFields.length == 0 || isAllFieldsMatch;
            if (canGetOptions) this.getOptionsDebounce("*", this.$refs.vselect.toggleLoading);
        }
        if (this.withOptionGroup) {
            this.options = this.shapeOptionGroupOptions(this.options);
        }

        if (this.formItem.isRunWatchFieldOnMount && typeof this.formItem.watchField == "function")
            this.formItem.watchField(this.value, this.formData);
    },
    created() {
        this.queryParamsFields = queryParamsFieldsCompletion(this.queryParamsFields);

        var self = this;
        this.getOptionsDebounce = this.isRemoteOptions
            ? _debounce(async function (queryValue, loading) {
                  try {
                      loading(true);

                      let options = await self.formItem.remoteOptions(queryValue, self.queryParams);
                      self.options = self.withOptionGroup ? self.shapeOptionGroupOptions(options) : options;
                      if (self.onQueryParamFieldsQueryIf == "firstAvailable") {
                          let availableOptions = options.filter((e) => !e.disabled);
                          if (!availableOptions.map((e) => e.value).includes(self.value)) {
                              self.onValueChanged(availableOptions[0].value);
                          }
                      }
                      loading(false);
                  } catch (err) {
                      loading(false);
                      console.log(err);
                  }
              })
            : () => {};

        // 監聽需要注意的欄位
        this.queryParamsFields.forEach((field) => {
            let { fieldName, queryIf } = field;
            this.$watch(
                function () {
                    return this.formData[fieldName];
                },
                function (newVal, oldVal) {
                    // console.log(`${this.formItem.key}: ${fieldName} changed from ${oldVal} to ${newVal}`);
                    // 有條件的獲取新選項
                    if (queryIf(newVal)) {
                        if (this.onQueryParamFieldsQueryIf == "resetField") {
                            this.$emit("input", this.formItem.defaultVal);
                        }
                        this.getOptionsDebounce("*", this.$refs.vselect.toggleLoading);
                    }
                },
                { deep: true }
            );
        });
    },
    computed: {
        multiple() {
            return typeof this.formItem.multiple == "function"
                ? this.formItem.multiple(this.value, this.formData)
                : this.formItem.multiple;
        },
        isRemoteOptions() {
            return typeof this.formItem.remoteOptions == "function";
        },
        queryParams() {
            let queryParams = {};
            this.queryParamsFields.forEach((field) => {
                let { fieldName } = field;
                queryParams[fieldName] = this.formData[fieldName];
            });
            return queryParams;
        },
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
    },
};
</script>
<style>
.select-group-title {
    font-size: 14px;
    color: #999;
    height: 30px;
    line-height: 30px;
}
.select-with-group {
    padding-left: 8px;
}
/* .vs__dropdown-menu {
    position: relative;
} */
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/Select/Select.vue